import { Autocomplete, Box, FormControl, FormLabel, Table, Textarea } from '@mui/joy'
import React from 'react'
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import { keyframes } from '@emotion/react';
function FragenBeantworteradvanced({ data, fragen, setfragen, bewertung, setbewertung }) {

    function setf(k,v){
        let s = new Map(fragen);
        s.set(k,v);
        setfragen(s);
    }
    function setb(k,b){
        let a = new Map(bewertung);
        a.set(k,b);
        setbewertung(a);
    }
    return (
        <Table sx={{ '& thead th:nth-child(3)': { width: '8%' } }}>
            <thead>
                <tr>
                    <th>Frage</th>
                    <th>Neu</th>
                    <th>Richtung</th>
                    <th>Alt</th>
                </tr>
            </thead>
            <tbody>
                {data && Array.isArray(data.fragen) &&
                    data.fragen
                        .slice()
                        .sort((a, b) => a.order - b.order)
                        .map((item, index) => {
                            const keys = Object.keys(item).filter(k => k !== "order");
                            const name = keys[0] || "Unbenannt";
                            return (
                                <React.Fragment key={`${index}-${name}`}>
                                    <tr>
                                        <td colSpan={3} style={{ fontWeight: 'bold' }}>{name}</td>
                                        <td />
                                    </tr>
                                    {Array.isArray(item[name]) &&
                                        item[name]
                                            .slice()
                                            .sort((a, b) => a.order - b.order)
                                            .map((frage, idx) => (
                                                <tr key={`${index}-${idx}`}>
                                                    <td>{frage.name}</td>
                                                    <td>
                                                        <Box sx={{ display: "flex", flexDirection: "column" }}>
                                                            <FormControl>
                                                                <FormLabel></FormLabel>
                                                                <Textarea value={fragen.get(frage.name)} onChange={
                                                                    (e) => setf(frage.name, e.target.value)
                                                                } minRows={5} sx={{bgcolor: "yellow"}}/>
                                                            </FormControl>
                                                            <Autocomplete sx={{bgcolor: "yellow"}} onChange={(e,newv) => setb(frage.name,newv)} value={bewertung.get(frage.name)} options={frage.bewertung} getOptionLabel={(e) => e.bzh}/>
                                                        </Box>
                                                    </td>
                                                    <td><ArrowCircleLeftOutlinedIcon /></td>
                                                    <td>
                                                        <Box sx={{display: "flex", flexDirection: "column"}}>
                                                                        <FormControl>
                                                                            <FormLabel></FormLabel>
                                                                            <Textarea
                                                                                minRows={5}
                                                                                value={data.lasttarif.questions.find((e) => e.question === frage.name)?.antwort}
                                                                                placeholder="Alt-Antwort..."
                                                                                variant="outlined"
                                                                            />
                                                                        </FormControl>
                                                                        <Autocomplete 
                                                                        getOptionLabel={(item) => item.bzh}
                                                                         options={frage.bewertung}
                                                                          value={frage.bewertung.find((e) => data.lasttarif.bewertung.find((i) => i.question === frage.name)?.bewertung == e.id)} />
                                                        </Box>
                                                    </td>
                                                </tr>
                                            ))}
                                </React.Fragment>
                            );
                        })}

            </tbody>
        </Table>
    )
}

export default FragenBeantworteradvanced
